import React from "react";
import { MessageSquare } from "lucide-react";
import Card from "components/card";

const TicketReplyCard = ({ 
    trp_message, 
    user_name,
    created_at_ago
}) => {
    const senderName = user_name || "Partner & Service Team";

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-2 rounded-xl border-2 border-slate-200 overflow-hidden">
            <div className="p-4 flex items-start gap-3">
                <div className="p-2 rounded-xl bg-purple-100 text-purple-700">
                    <MessageSquare className="w-4 h-4" />
                </div>
                <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                        <p className="font-semibold text-[13px]">{senderName}</p>
                        <span className="text-[11px] text-slate-700">{created_at_ago}</span>
                    </div>
                    <p className="text-[11px] text-slate-700">{trp_message}</p>
                </div>
            </div>
        </Card>
    );
};

export default TicketReplyCard;